<template>
  <AppGradientBackground class="overflow-x-hidden pb-80">
    <AppSkipLink href="#main" />
    <HeaderNavBar />
    <main id="main" class="min-h-screen android-chrome-safe-padding">
      <div class="page-wrapper">
        <slot name="top" />

        <div class="flex flex-col lg:flex-row gap-24 pb-120">
          <div class="w-full block lg:hidden">
            <slot name="cart-column" />
          </div>
          <div class="w-full">
            <slot name="formsteps-column" />
          </div>
          <div class="w-full hidden lg:block">
            <slot name="cart-column" />
          </div>
        </div>
      </div>
    </main>
  </AppGradientBackground>
</template>

<script lang="ts" setup></script>
